import { connect } from "react-redux";
import Welcome from "../../components/app/ThankYou";
import {
  setStage,
  callGoogleAnalytics,
  Stages,
  setIsCalProvider,
  setLoader,
  callGoogleAnalyticsEvent,
} from "../../actions/actions";
import { goToUrl } from "../../actions/services";

const mapDispatchToProps = (dispatch) => {
  return {
    onShowPopup: () => {
      dispatch(
        callGoogleAnalytics(window.settings.ga.pages.thankYouAnotherCode)
      );
      dispatch(
        callGoogleAnalyticsEvent(
          "online-secret-code",
          "thank-you",
          "view-another-card"
        )
      );
      dispatch(setIsCalProvider(window.isCalProvider));
      dispatch(setStage(Stages.cards));
      dispatch(setLoader(false));
    },
    onClosePopup: () => {
      dispatch(
        callGoogleAnalytics(window.settings.ga.pages.thankYouCalWebsite)
      );
      if (window.hidenavbar == "false" || window.hidenavbar == false) {
        goToUrl(window.settings.provider.homeSiteUrl);
      } else {
        goToUrl(window.returnAppUrl);
      }
    },
    goToCalSite: () => {
      dispatch(
        callGoogleAnalyticsEvent(
          "online-secret-code",
          "thank-you",
          "exit-cal-website"
        )
      );
      if (window.hidenavbar == "false" || window.hidenavbar == false) {
        window.location.href = window.settings.provider.homeSiteUrl;
      } else {
        window.location.href = window.returnAppUrl;
      }
    },
    onRestart: () => {
      dispatch(setStage(Stages.login));
      dispatch(setIsCalProvider(window.isCalProvider));
    },
    onGoSecretCodeDetails: () => {
      dispatch(
        callGoogleAnalyticsEvent(
          "online-secret-code",
          "thank-you",
          "choose-pin-code"
        )
      );
      window.location.href =
        "https://www.cal-online.co.il/self-service/choose-pin-code";
    },
  };
};

const mapStateToProps = (state) => {
  return {
    message: state.session.app.message
      ? state.session.app.message.restart
      : null,
    cards: state.session.card ? state.session.card : null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/app/ThankYou.js